// extracted by mini-css-extract-plugin
export default {"method":"MethodInput_method__fJmyY","close":"MethodInput_close__cBCRK","step":"MethodInput_step__+Bsax","index":"MethodInput_index__2nLkm"};